import React from 'react';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { types as sdkTypes } from '../../util/sdkLoader';
import css from './OrderBreakdown.module.css';

const { Money } = sdkTypes;

const LineItemProtection = props => {
  const { lineItems, intl, handleProtection ,isProtection } = props;

  const totalLineItem = lineItems.find(item => item.code === 'line-item/night' && !item.reversal);
  const totalAmount = totalLineItem ? totalLineItem.lineTotal.amount : 0;
  const currency = totalLineItem ? totalLineItem.lineTotal.currency : 'USD';
  const protectionAmount = Math.round(totalAmount * 0.03); // 3% of total

  return (
    <div className={css.lineItem}>
      <div className={css.protectionBox}>
        <div className={css.headerRow}>
          <span className={css.itemLabel}>
            <FormattedMessage
              id="OrderBreakdown.protectionTitle"
              defaultMessage="Make my trip refundable*"
            />
          </span>
          <span className={css.itemValue}>
            +{formatMoney(intl, new Money(protectionAmount, currency))}
          </span>
        </div>
        <p className={css.smallPrint}>
          <FormattedMessage
            id="OrderBreakdown.cancelAnytime"
            defaultMessage="Cancel anytime."
          />
        </p>
        <div className={css.optionGroup}>
          <label className={css.option}>
            <input
              type="radio"
              name="refundOption"
              value="yes"
              checked={!!isProtection}
              onChange={() => handleProtection(protectionAmount)}
            />
            <FormattedMessage
              id="OrderBreakdown.refundYes"
              defaultMessage="Yes, I want to add refund protection"
            />
          </label>
          <label className={css.option}>
            <input
              type="radio"
              name="refundOption"
              value="no"
              checked={!isProtection}
              onChange={() => handleProtection(false)}
            />
            <FormattedMessage
              id="OrderBreakdown.refundNo"
              defaultMessage="No, I understand my trip won’t be refundable"
            />
          </label>
        </div>
        {/* <p className={css.asteriskNote}>
          <FormattedMessage
            id="OrderBreakdown.protectionNote"
            defaultMessage="*3% of total cost. Refund conditions apply."
          />
        </p> */}
      </div>
    </div>
  );
};

LineItemProtection.propTypes = {
  intl: intlShape.isRequired,
};

export default LineItemProtection;
